import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardFooter } from '@/components/ui-kit/card';
import { CalendarPlus2, Folder } from 'lucide-react';
import { FolderCardDropdown } from './folder-card-dropdown';
import Link from '@/components/core/router-link';
import { parseBackendUtc } from '@/modules/gpt-chats/utils/date-utils';
import { IFolder } from '@/modules/gpt-chats/types/kb.service.type';

export const FolderCard = ({ folder }: { folder: IFolder }) => {
  const { t } = useTranslation();
  return (
    <Card className="w-75 group relative flex h-full cursor-pointer flex-col items-start gap-4 rounded-md transition hover:bg-accent hover:shadow-sm">
      <Link to={`/ai/knowledge-base/${folder._id}`} className="absolute inset-0 z-0" />
      <CardContent className="pointer-events-none flex w-full flex-1 flex-col gap-4">
        <div className="pointer-events-auto flex flex-row items-center justify-between">
          <div className="flex items-start gap-2">
            <Folder className="aspect-square h-6 w-6" />
            <h3 className="text-lg font-semibold">{folder.Name ?? t('UNNAMED_FOLDER')}</h3>
          </div>
          <div className="relative z-10">
            <FolderCardDropdown folder={folder} />
          </div>
        </div>

        {folder?.Description && (
          <p className="font-sm line-clamp-2 break-all text-medium-emphasis">
            {folder.Description}
          </p>
        )}
      </CardContent>
      <CardFooter className="pointer-events-none flex flex-col items-start gap-1">
        <div className="flex flex-row items-center gap-2">
          <CalendarPlus2 className="aspect-square h-4 w-4" />
          <span className="text-sm text-medium-emphasis">
            {parseBackendUtc(folder.CreatedDate as string).toLocaleString('en-GB', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            })}
          </span>
        </div>
      </CardFooter>
    </Card>
  );
};
